import { GenericBasketItem } from '@/types';

export const getContextIdAndProductTypeIdOfBasketItem = (basketItem: GenericBasketItem) => {
  return [basketItem.shopId, basketItem.productTypeId];
};
